import PeopleIcon from "@mui/icons-material/People";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import React, { useState } from "react";
import AllUsers from "../../components/AllUsers";
import CustomerInfoModal from "../../components/CustomerInfoModal";
import ModalWindow from "../../components/modal/ModalWindow";
import WebUsers from "../../components/WebUsers";

const AdminUsersPage = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [userModalVisible, setUserModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("users");

  const handleRowClick = (user) => {
    setSelectedUser(user);
    setUserModalVisible(true);
  };

  const userColumns = [
    { id: "cisloOdberatele", label: "Číslo odběratele" },
    { id: "nazev", label: "Název" },
    { id: "adresa", label: "Adresa", renderCell: (value) => value || "-" },
    { id: "emailOrsoft", label: "E-mail Orsoft", renderCell: (value) => value || "-" },
    { id: "emailMfa", label: "E-mail MFA", renderCell: (value) => value || "-" },
    { id: "telefon", label: "Telefon", renderCell: (value) => value || "-" },
  ];

  return (
    <>
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Typography variant="h4" sx={{ mb: 2 }}>
          Odběratele
        </Typography>

        <ButtonGroup
          variant="contained"
          aria-label="Platby navigation"
          sx={{ mb: 3 }}
        >
          <Button
            onClick={() => setActiveTab("users")}
            startIcon={
              <PeopleIcon color={activeTab === "users" ? "white" : "primary"} />
            }
            color={activeTab === "users" ? "primary" : "white"}
          >
            Odběratele
          </Button>
          <Button
            onClick={() => setActiveTab("superusers")}
            startIcon={
              <SupervisedUserCircleIcon
                color={activeTab === "superusers" ? "white" : "primary"}
              />
            }
            color={activeTab === "superusers" ? "primary" : "white"}
          >
            Web odběratele
          </Button>
        </ButtonGroup>
      </Box>
      {activeTab === "users" ? (
        <AllUsers
          customerColumns={userColumns}
          handleRowClick={handleRowClick}
        />
      ) : (
        <WebUsers
          customerColumns={userColumns}
          handleRowClick={handleRowClick}
        />
      )}

      {selectedUser && (
        <ModalWindow
          visible={userModalVisible}
          setVisible={setUserModalVisible}
        >
          <CustomerInfoModal selectedCustomer={selectedUser} />
        </ModalWindow>
      )}
    </>
  );
};

export default AdminUsersPage;
